'use es6';

import { Record, Set as ImmutableSet } from 'immutable';
export default Record({
  id: null,
  answerIds: ImmutableSet(),
  correctAnswer: null,
  questionId: null,
  quizAttemptId: null,
  submissionTime: null
}, 'AnswerSubmission');